//select component for large screens (>=420px)

import React, { useCallback, useEffect, useRef, useState } from "react";
// import styles from "./SelectComponent.module.css";
import clsx from "clsx";
import {
  CaretDownIcon,
  ChevronDownIcon,
  DropdownIcon,
  EllipseIcon,
  InfoIcon,
  UpvoteIcon,
} from "lib/components/Icon";
import { FiChevronDown } from "react-icons/fi";

interface SelectProps {
  optionLabel: string;
  name: string;
  id: string;
  options: Array<any> | readonly any[];
  className: string;
  optionStyle?: string;
  value?: string;
  onChange?: (e: any) => void;
  label?: string;
  required?: boolean;
  setFilled?: () => void;
}

export default function Select({
  value,
  optionLabel,
  name,
  id,
  options,
  className,
  optionStyle,
  onChange,
  label,
  setFilled,
  required,
  ...rest
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [placeHolder, setPlaceHolder] = useState("");
  const [selected, setSelected] = useState(value ? value : optionLabel);

  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const handleChange = (e: any, value: string) => {
    setSelected(value);
    setFilled && setFilled();
    onChange && onChange(e);
    setIsOpen(!isOpen);
  };

  const toggling = () => setIsOpen(!isOpen);

  useEffect(() => {
    function handleClickOutside(event: { target: any }) {
      if (
        wrapperRef &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    queueMicrotask(() => setPlaceHolder(optionLabel));
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [optionLabel, wrapperRef]);

  return (
    <>
      {label && label.length > 0 && (
        <span className="mb-1 font-medium">
          {label}
          {required && <span className="text-red-600 ml-1">*</span>}
        </span>
      )}

      <div
        className={clsx(
          "flex flex-col flex-wrap relative align-items-center cursor-pointer ",
        )}
        ref={wrapperRef}
      >
        <div
          onClick={toggling}
          className={clsx("py-2 px-2 font-medium rounded text-gray-900 dark:text-gray-100", className)}
        >
          {selected}
        </div>

        {isOpen && (
          <div>
            <ul
              className={clsx("absolute bg-gray-50 dark:bg-gray-700 min-w-full z-50", optionStyle)}
            >
              {options.map((option) => (
                <li
                  id={typeof option === "string" ? option : option._id.$oid}
                  onClick={(e) => {
                    handleChange(
                      e,
                      typeof option === "string" ? option : option.name,
                    );
                  }}
                  key={typeof option === "string" ? option : option._id.$oid}
                  className="text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-600 p-2 overflow-hidden selectItem"
                >
                  {typeof option === "string" ? option : option.name}
                </li>
              ))}
            </ul>
          </div>
        )}
        <span
          className={clsx("absolute h-full flex align-items-center right-2  ")}
        >
          <FiChevronDown className="w-5 my-auto" />
        </span>
      </div>
    </>
  );
}
